import React from "react";
import Navbar1 from "./layout/navbar/Navbar1";
import { FiSliders } from "react-icons/fi";
const Table = () => {
  const transactions = [
    {
      id: 1,
      date: "16",
      month: "OCT",
      time: "02:45",
      description: "Payment Method",
      description2: "Lorem Ipsum is simply dummy text of",
      description3: "the printing and typesetting industry.",
      description4: "0123548",
      creditdebit: "Debit",
      status: "-",
      amount: "40,000/-",
    },
    // {
    //   id: 2,
    //   date: "16",
    //   month: "OCT",

    //   description: "Lorem Ipsum is simpky dummy text if",
    //   creditdebit: "Debit",
    //   staus: "-",
    //   amount: "40,000/-",
    // },
  ];

  const events = [
    {
      id: 1,
      date: "16",
      month: "OCT",
      description: "Event Name",
      description2:
        "Lorem Ipsum is simply dummy text of the printing and typesetting",
      description3: "industry.Lorem Ipsum is simply dummy text",
      status: "Done",
    },
    // {
    //   id: 2,
    //   date: "16",
    //   month: "OCT",
    //   eventName:
    //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    // },
  ];

  return (
    <>
      <div className="mx-md-5 px-md-5 ">
        <div style={{ borderRadius: "2rem" }} className="border border-1 py-4">
          <div className="row mx-md-3 px-md-3 mx-lg-5 px-lg-5">
            <div className="col-md-6">
              <h2 style={{fontSize: "1.75rem"}} className="fw-bold">Transaction Details</h2>
            </div>
            <div className="col-md-6 d-flex justify-content-between">
              <div class="mb-3">
                <button
                  class="btn d-flex shadow-none"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    fontWeight: "bold",
                    height: "2.5rem",
                    width: "5.75rem",
                    backgroundColor: "#f7fafc",
                    border: "1px solid #E2E8F0",
                  }}
                >
                  <div className="d-flex gap-2">
                    <FiSliders className="mt-1" />
                    <p className="mt-1" style={{ fontSize: "0.75rem" }}>
                      {" "}
                      FILTER
                    </p>
                  </div>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li>
                    <a class="dropdown-item border-bottom" href="#">
                      Date
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" href="#">
                      History
                    </a>
                  </li>
                </ul>
              </div>
              <h6
                style={{ color: "#395998" }}
                className="text-decoration-underline"
              >
                Statement
              </h6>
            </div>
          </div>

          {transactions.map((transaction) => {
            const {
              date,
              month,
              time,
              description,
              description2,
              description3,
              description4,
              creditdebit,
              status,
              amount,
            } = transaction;
            return (
              
              <div className="d-flex justify-content-center table-responsive table">
                <table  style={{ width: "67vw" }} className="table mx-md-5">
                  <thead className="border-top border-bottom">
                    <tr className="">
                      <th
                        style={{ color: "#545558" }}
                        className="ps-md-4 py-3 fw-normal"
                      >
                        Date
                      </th>
                      <th
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-5 fw-normal"
                      >
                        Description{" "}
                      </th>
                      <th style={{ color: "#545558" }} className="fw-normal">
                        Credit/Debit
                      </th>
                      <th
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-4 fw-normal"
                      >
                        Status
                      </th>
                      <th
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-5 fw-normal"
                      >
                        Amount
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-bottom">
                      <td className="py-1">
                        <div
                          class="border-0 rounded-0 p-0"
                          style={{
                            backgroundColor: "#FFDD80",
                            width: "4.625rem",
                            height: "6.063rem",
                          }}
                        >
                          <h5
                            style={{ color: "#545558" }}
                            className="text-center pt-2 m-0"
                          >
                            <strong>{date}</strong>
                          </h5>
                          <p
                            style={{ color: "#545558" }}
                            className="text-center transactiondetailsorder3 mb-2"
                          >
                            {month}
                          </p>
                          <h6
                            style={{ fontSize: "0.875rem", color: "#545558" }}
                            className="text-center"
                          >
                            {time}&nbsp;<strong>PM</strong>
                          </h6>
                        </div>
                      </td>
                      <td className="">
                        <p className="ms-md-5 ps-md-1 pt-4">
                          <strong>{description}</strong>
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 m-0"
                        >
                          {description2}
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 "
                        >
                          {description3}
                        </p>
                        <div className="d-md-flex gap-2 align-items-center">
                          <p className="ms-md-5 ps-md-1">
                            <strong
                              style={{ fontSize: "0.875rem", color: "#545558" }}
                            >
                              Transaction Id
                            </strong>
                          </p>
                          <p style={{ fontSize: "0.875rem" }}>{description4}</p>
                        </div>
                      </td>
                      <td
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-4"
                      >
                        {creditdebit}
                      </td>
                      <td style={{ color: "#545558" }} className="ms-5 ps-5">
                        {status}
                      </td>
                      <td style={{ color: "#545558" }} className="ms-5 ps-5">
                        {amount}
                      </td>
                    </tr>
                    <tr className="border-bottom">
                      <td className="py-1">
                        <div
                          class="border-0 rounded-0 p-0"
                          style={{
                            backgroundColor: "#FFDD80",
                            width: "4.625rem",
                            height: "6.063rem",
                          }}
                        >
                          <h5
                            style={{ color: "#545558" }}
                            className="text-center pt-2 m-0"
                          >
                            <strong>{date}</strong>
                          </h5>
                          <p
                            style={{ color: "#545558" }}
                            className="text-center transactiondetailsorder3 mb-2"
                          >
                            {month}
                          </p>
                          <h6
                            style={{ fontSize: "0.875rem", color: "#545558" }}
                            className="text-center"
                          >
                            {time}&nbsp;<strong>PM</strong>
                          </h6>
                        </div>
                      </td>
                      <td>
                        <p className="ms-md-5 ps-md-1 pt-4">
                          <strong>{description}</strong>
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 m-0"
                        >
                          {description2}
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 "
                        >
                          {description3}
                        </p>
                        <div className="d-md-flex gap-2 align-items-center">
                          <p className="ms-md-5 ps-md-1">
                            <strong
                              style={{ fontSize: "0.875rem", color: "#545558" }}
                            >
                              Transaction Id
                            </strong>
                          </p>
                          <p style={{ fontSize: "0.875rem" }}>{description4}</p>
                        </div>
                      </td>

                      <td
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-4"
                      >
                        {creditdebit}
                      </td>
                      <td style={{ color: "#545558" }} className="ms-5 ps-5">
                        {status}
                      </td>
                      <td style={{ color: "#545558" }} className="ms-5 ps-5">
                        {amount}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            );
          })}
          <div className="text-end pt-5 me-5 pe-5">
            <h6
              className="text-decoration-underline"
              style={{ color: "#395998" }}
            >
              See All
            </h6>
          </div>
        </div>
      </div>

      <div className="mx-md-5 px-md-5 pt-4 ">
        <div style={{ borderRadius: "2rem" }} className="border border-1 py-4">
          <div className="d-flex justify-content-between mx-5 px-5">
            <h2 style={{fontSize: "1.75rem"}} className="fw-bold">Event Details</h2>

            <div class="mb-3 me-4">
              <button
                class="btn d-flex shadow-none"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  fontWeight: "bold",
                  height: "2.5rem",
                  width: "5.75rem",
                  backgroundColor: "#f7fafc",
                  border: "1px solid #E2E8F0",
                }}
              >
                <div className="d-flex gap-2">
                  <FiSliders className="mt-1" />
                  <p className="mt-1" style={{ fontSize: "0.75rem" }}>
                    {" "}
                    FILTER
                  </p>
                </div>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item border-bottom" href="#">
                    Date
                  </a>
                </li>
                <li>
                  <a class="dropdown-item" href="#">
                    History
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {events.map((event) => {
            const {
              date,
              month,
              description,
              description2,
              description3,
              status,
            } = event;
            return (
              <div className="d-flex justify-content-center">
                <table style={{ width: "67vw" }} className="mx-md-5">
                  <thead className="border-top border-bottom">
                    <tr className="">
                      <th
                        style={{ color: "#545558" }}
                        className="ps-md-3 py-3 fw-normal"
                      >
                        Date
                      </th>
                      <th
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-5 fw-normal"
                      >
                        Description{" "}
                      </th>
                      <th style={{ color: "#545558" }} className="fw-normal">
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-bottom">
                      <td className="py-1">
                        <div
                          class="border-0 rounded-0 p-0"
                          style={{
                            backgroundColor: "#FFDD80",
                            width: "4.625rem",
                            height: "4.188rem",
                          }}
                        >
                          <h5
                            style={{ color: "#545558" }}
                            className="text-center pt-2 m-0"
                          >
                            <strong>{date}</strong>
                          </h5>
                          <p
                            style={{ color: "#545558", color: "#545558" }}
                            className="text-center  mb-2"
                          >
                            {month}
                          </p>
                        </div>
                      </td>
                      <td className="">
                        <p className="ms-md-5 ps-md-1 pt-4">
                          <strong>{description}</strong>
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 m-0"
                        >
                          {description2}
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 "
                        >
                          {description3}
                        </p>
                      </td>
                      <td
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-1"
                      >
                        {status}
                      </td>
                      {/* <td className="ms-5 ps-5">{status}</td>
                      <td className="ms-5 ps-5">{amount}</td> */}
                    </tr>
                    <tr className="border-bottom">
                      <td className="py-1">
                        <div
                          class="border-0 rounded-0 p-0"
                          style={{
                            backgroundColor: "#FFDD80",
                            width: "4.625rem",
                            height: "4.188rem",
                          }}
                        >
                          <h5
                            style={{ color: "#545558" }}
                            className="text-center pt-2 m-0"
                          >
                            <strong>{date}</strong>
                          </h5>
                          <p
                            style={{ color: "#545558" }}
                            className="text-center mb-2"
                          >
                            {month}
                          </p>
                        </div>
                      </td>
                      <td>
                        <p className="ms-md-5 ps-md-1 pt-4">
                          <strong>{description}</strong>
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 m-0"
                        >
                          {description2}
                        </p>
                        <p
                          style={{ fontSize: "0.875rem", color: "#545558" }}
                          className="ms-md-5 ps-md-1 "
                        >
                          {description3}
                        </p>
                      </td>

                      <td
                        style={{ color: "#545558" }}
                        className="ms-md-5 ps-md-1"
                      >
                        {status}
                      </td>
                    </tr>
                    {/* <td className="ms-5 ps-5">{status}</td>
                    <td className="ms-5 ps-5">{amount}</td> */}
                  </tbody>
                </table>
              </div>
            );
          })}
          <div className="text-end pt-5 me-5 pe-5">
            <h6
              className="text-decoration-underline"
              style={{ color: "#395998" }}
            >
              See All
            </h6>
          </div>
        </div>



      </div>
    </>
  );
};

export default Table;
